export default "__VITE_ASSET__03cbb9d7__"